import type { ReviewRecord } from "./discrepancy-review-controls";
import { tokens } from "@/tokens";
export { formatCurrency, formatCurrencyPrecise } from "@/utils";

export const getSeverityConfig = (severity: string) => {
  const configs: Record<string, { bg: string; text: string }> = {
    HIGH: { bg: tokens.status.dangerBg, text: tokens.status.danger },
    MEDIUM: { bg: tokens.status.warningBg, text: tokens.status.warning },
    LOW: { bg: tokens.status.infoBg, text: tokens.status.info },
    INFO: { bg: tokens.bg.muted, text: tokens.text.secondary },
  };
  return configs[severity] || configs.INFO;
};

export const getItemKey = (item: ValueDiscrepancyItem): string =>
  `${item.auditId}:${item.discrepancyId}`;

export const itemToReviewRecord = (item: ValueDiscrepancyItem): ReviewRecord | null => {
  if (!item.reviewStatus && (!item.reviewComments || item.reviewComments.length === 0)) {
    return null;
  }
  return {
    status: item.reviewStatus || null,
    statusSetBy: item.reviewStatusSetBy || null,
    statusSetAt: item.reviewStatusSetAt || null,
    comments: (item.reviewComments || []).map((c) => ({
      id: c.id,
      text: c.text,
      authorId: c.authorId,
      authorName: c.authorName,
      createdAt: c.createdAt,
    })),
  };
};

export const getClassificationItemKey = (item: ClassificationDiscrepancyItem): string =>
  `${item.auditId}:${item.discrepancyId}`;

export const classificationItemToReviewRecord = (item: ClassificationDiscrepancyItem): ReviewRecord | null => {
  if (!item.reviewStatus && (!item.reviewComments || item.reviewComments.length === 0)) {
    return null;
  }
  return {
    status: item.reviewStatus || null,
    statusSetBy: item.reviewStatusSetBy || null,
    statusSetAt: item.reviewStatusSetAt || null,
    comments: (item.reviewComments || []).map((c) => ({
      id: c.id,
      text: c.text,
      authorId: c.authorId,
      authorName: c.authorName,
      createdAt: c.createdAt,
    })),
  };
};

export const COLUMNS = [
  { key: 'checkbox', label: '', padding: 'checkbox' as const },
  { key: 'entryNumber', label: 'Entry #' },
  { key: 'entryDate', label: 'Entry Date' },
  { key: 'severity', label: 'Severity' },
  { key: 'title', label: 'Title' },
  { key: 'declared', label: 'Declared', align: 'right' as const },
  { key: 'discrepancy', label: 'Discrepancy', align: 'right' as const },
  { key: 'estDuty', label: "Add'l Duty", align: 'right' as const },
  { key: 'status', label: 'Status' },
];
